import axios from 'axios';
const appWrapper = document.querySelector('.cfs-agenda');
const url = appWrapper?.dataset?.url
	? appWrapper.dataset.url
	: window.location.host;
let DATA_URL = `${url}/wp-json/agenda`;

if (process.env.NODE_ENV !== 'production') {
	DATA_URL = 'https://cloudfest.ddev.site/wp-json/agenda';
}

export const serviceGetFilters = () => {
	return axios.get(`${DATA_URL}/v2/filters`);
};

export const serviceGetTalks = () => {
	return axios.get(`${DATA_URL}/v2/talks`);
};

export const serviceGetTalk = (postId = 0) => {
	// const defaultParams = {method: 'POST'};
	// params = {...defaultParams, ...params};
	const endpoint = postId > 0 ? `/v2/talk/${postId}` : '/v2/talk';
	return axios.get(`${DATA_URL}${endpoint}`);
};
